export default function AtcFlightsCarouselController(
    $scope,
    $controller,
    atcFlightsFactory
) {
    'ngInject';

    $controller('atcFlightsCarouselBaseController', {
        $scope,
        atcFlightsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsCarouselController.js